import { Box, Stack } from "@mui/material";
import PageTitle from "../../../Displays/PageTitle";
import { useLocation } from "react-router-dom";
import PageSubTitle from "../../../Displays/PageSubTitle";
import { SELF_ONBOARDING_ROUTES } from "src/consts/Routes/SelfOnboarding";
import VerticalLinearProgress from "../../VerticalLinearProgressBar";

const SelfOnboardingProgressBar = () => {
  const { pathname } = useLocation();

  return (
    <Stack
      gap="13px"
      sx={{
        display: { xs: "none", sm: "flex" },
      }}
    >
      <PageTitle text={"Menü"} />
      {SELF_ONBOARDING_ROUTES.includes(pathname) && (
        <Box
          sx={{
            gap: 3,
            height: 20,
            display: { xs: "flex", sm: "default" },
          }}
        >
          <VerticalLinearProgress variant="determinate" />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "16px",
            }}
          >
            <PageSubTitle text={"Hardware Auswahl"} />
          </Box>
        </Box>
      )}
    </Stack>
  );
};

export default SelfOnboardingProgressBar;
